<section class="about-carousel fixed-top w-100 h-100 d-flex justify-content-between align-items-center">
        <button
            class="btn about-carousel__close-btn rounded-0 bg-white px-3 py-1 position-absolute text-uppercase fs-6"
            (click)="exitFull(true)"
        >
            Exit FullScreen
        </button>

        <button (click)="onPrev()" class="btn carousel__navigation-btn p-0 me-2 d-none d-md-block">
            <img
                class="navigation-btn__img"
                src="../../../../assets/icons/arrow.svg"
                alt="left-arrow"
            />
        </button>

        <swiper-container
            #swiperContainer
            class="swiperContainer h-100"
            slider-per-view="1"
            space-between="80"
            pagination="true"
            pagination-clickable="true"
            loop="true"
        >
            <swiper-slide class="d-flex justify-content-center align-items-center">
                <img
                    src="../../../../assets/imgs/collage/1.webp"
                    alt="city tour street"
                    class="about-carousel__img"
                />
            </swiper-slide>
            <swiper-slide class="d-flex justify-content-center align-items-center">
                <img
                    src="../../../../assets/imgs/collage/2.webp"
                    alt="farm and countryside horses"
                    class="about-carousel__img"
                />
            </swiper-slide>
            <swiper-slide class="d-flex justify-content-center align-items-center">
                <img
                    src="../../../../assets/imgs/collage/3.webp"
                    alt="iguazu waterfall"
                    class="about-carousel__img"
                />
            </swiper-slide>
            <swiper-slide class="d-flex justify-content-center align-items-center">
                <img
                    src="../../../../assets/imgs/collage/4.webp"
                    alt="la ventana show"
                    class="about-carousel__img"
                />
            </swiper-slide>
            <swiper-slide class="d-flex justify-content-center align-items-center">
                <img
                    src="../../../../assets/imgs/collage/5.webp"
                    alt="montevideo at night"
                    class="about-carousel__img"
                />
            </swiper-slide>
            <swiper-slide class="d-flex justify-content-center align-items-center">
                <img
                    src="../../../../assets/imgs/collage/6.webp"
                    alt="rojo tango show"
                    class="about-carousel__img"
                />
            </swiper-slide>
            <swiper-slide class="d-flex justify-content-center align-items-center">
                <img
                    src="../../../../assets/imgs/collage/7.webp"
                    alt="wine urban art street art"
                    class="about-carousel__img"
                />
            </swiper-slide>
            <swiper-slide class="d-flex justify-content-center align-items-center">
                <img
                    src="../../../../assets/imgs/collage/8.webp"
                    alt="city colon streets"
                    class="about-carousel__img"
                />
            </swiper-slide>
            <swiper-slide class="d-flex justify-content-center align-items-center">
                <img
                    src="../../../../assets/imgs/collage/9.webp"
                    alt="city colon tour"
                    class="about-carousel__img"
                />
            </swiper-slide>
            <swiper-slide class="d-flex justify-content-center align-items-center">
                <img
                    src="../../../../assets/imgs/collage/10.webp"
                    alt="floralis generica"
                    class="about-carousel__img"
                />
            </swiper-slide>
            <swiper-slide class="d-flex justify-content-center align-items-center">
                <img
                    src="../../../../assets/imgs/collage/11.webp"
                    alt="tigre boat on water"
                    class="about-carousel__img"
                />
            </swiper-slide>
            <swiper-slide class="d-flex justify-content-center align-items-center">
                <img
                    src="../../../../assets/imgs/collage/12.webp"
                    alt="wine urban art tour"
                    class="about-carousel__img"
                />
            </swiper-slide>
        </swiper-container>

        <button
            (click)="onNext()"
            class="btn carousel__navigation-btn carousel__navigation-btn--next p-0 ms-2 d-none d-md-block"
        >
            <img
                class="navigation-btn__img"
                src="../../../../assets/icons/arrow.svg"
                alt="rigth-arrow"
            />
        </button>
</section>
